<template>
  <div id="home">
    <my-header ></my-header>
          <!-- <div class="image-store height-auto">
            <img src="/static/images/cover-store.jpg" />
          </div> -->
    <div class="pd20">
      <h3 class="text-center">{{'Manufacturers'|translate}}</h3>
    <loading v-if="waiting_location" class="mt10 text-center" :text="'Please accept to help us get your location'|translate"></loading>
      <div class="home-div" v-else>

            <div class="well">
              <label>{{'Nhập sản phẩm muốn tìm '|translate}}:</label>
                <input
                  name="tags"
                  class="some_class_name"
                  placeholder="nhập tên sản phẩm"
                  value
                  autofocus
                />

                <label class="mt10" >{{'Sắp xếp theo'|translate}}:</label>
                <div  v-for="option in sort_options" :key="option.key">
                  <input type="radio" required :id="option.key"   :value="option.key" v-model="search_params.order" v-on:change="searchManufacturers()" >
                  <label class="normal" :for="option.key">{{option.label}}</label>
                </div>
            </div>
            <loading v-if="working" :text="'Please wait'|translate"></loading>
            <div class="row-flex row mt20" v-if="!working">

              <div class="col-md-12 col-xs-12" v-if="search_result.length== 0 && !show_suggestion ">
                <div class="alert alert-info" role="alert">{{'No result'|translate}}</div>
              </div>

              <div class="col-md-4 col-xs-6 mb10"  v-else v-for="(item) in search_result" :key="item.id">
                <div class="media search-item pd10">

                      <img
                        class="media-object"
                        style="width:100%"
                        v-if="item.photos.length == 0"
                        src="/static/images/no-photo.jpg"
                      />
                      <a class="inline-block"  v-else  @click="clickPhoto(item,0)" >
                        <img  :src="item.photos[0].thumb_path" width="100%" >
                       </a>

                  <div class="media-body">
                      <p><strong>{{item.product.name}}</strong></p>
                      <p>{{item.address}}</p>
                      <p v-if="item.price">Giá: {{toCommas(item.price)}} VND</p>
                      <p v-for="phone in item.phones" v-bind:key="phone" >
                        <a v-if="!is_loggedin" class="pointer" @click="alertNeedLogin" ><i class="fas fa-phone"></i> {{phone}}</a>
                        <a v-else :href="'tel:'+phone">
                      <i class="fas fa-phone"></i> {{phone}}
                        </a>
                      </p>
                  </div>
                </div>
              </div>

               <gallery v-if="photos" :images="photos" :index="index" @close="index = null"></gallery>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import LocationHelper from '@/helpers/location'
import MyHeader from '@/components/Layout/Header'
import Autocomplete from 'vuejs-auto-complete'
import advantagesearch from '@/components/elements/AdvantageSearch'
import CurrentAddressControl from '@/components/elements/CurrentAddressControl'
import gallery from 'vue-gallery'
import Loading from '@/components/elements/Loading'
import Tagify from '@yaireo/tagify'
export default {
  name: 'Home',
  components: {
    MyHeader,
    Autocomplete,
    advantagesearch,
    CurrentAddressControl,
    Loading,
    gallery
  },
  data () {
    return {
      show_suggestion: false,
      waiting_location: true,
      working: true,
      index: null,
      is_loggedin: false,
      photos: [],
      products: [],
      tagify: null,
      search_result: [],
      sort_options: [
        {
          key: 'date',
          label: 'Mới nhất'
        },
        {
          key: 'location',
          label: 'Gần nhất'
        },
        {
          key: 'price',
          label: 'Giá rẻ nhất'
        }
      ],
      search_params: {
        address: '',
        order: 'location',
        lat: null,
        lng: null,
        dist: 0
      }
    }
  },

  methods: {
    clickPhoto (item, photoIndex) {
      this.photos = item.photos.map(item => {
        return item.path
      })
      this.index = photoIndex
    },
    alertNeedLogin () {
      this.$alertify.error(this.$t('Bạn cần đăng nhập để xem số điện thoại'))
      window.REQUIRE_LOGIN_ROUTE_NAME = 'Manufacturers' // set callback after login
      this.$router.push({ name: 'Login' })
      // this.$alertify.alertWithTitle(
      //   this.$t("Confirm"),
      //   this.$t(
      //     "Bạn cần đăng nhập để xem số điện thoại"
      //   )
      // ).then(()=>{
      //   console.log('done redirect');
      // })
    },
    toCommas (value) {
      return Utils.toCommas(value)
    },
    searchManufacturers () {
      this.working = true

      let params = {
        sort: this.search_params.order
      }

      if (this.search_params.order == 'location') {
        params.lat = this.search_params.lat
        params.lng = this.search_params.lng
      }

      if (this.tagify && this.tagify.value.length > 0) {
        let product_names = this.tagify.value.map(item => {
          return item.value
        })
        let product_ids = this.products
          .filter(item => {
            return product_names.indexOf(item.name) != -1
          })
          .map(item => {
            return item.id
          })
        if (product_ids.length > 0) {
          params.product_ids = product_ids.join(',')
        }
      }

      console.log('params', params)
      Utils.requestV2(this, true)
        .get(`/product-manufacturers/?${Utils.arrayToRequestParam(params)}`)
        .then(response => {
          this.working = false
          this.search_result = response.data
          this.search_result = this.search_result.map(item => {
            item.phones = item.phone ? item.phone.split(',') : []
            if (!this.is_loggedin) {
              item.phones = item.phones.map(phone => {
                return phone.substr(0, 5) + '*****'
              })
            }
            return item
          })
        })
        .catch(error => {})
    },
    getProducts () {
      Utils.getAllProducts(this, {}).then(products => {
        console.log('products', products)
        this.products = products

        setTimeout(() => {
          let input = document.querySelector('input[name=tags]')
          // init Tagify script on the above inputs
          let whiteList = []
          if (this.products.length > 0) {
            whiteList = this.products.map(function (item) {
              return item.name
            })
          }
          // console.log("whiteList", whiteList);
          this.tagify = new Tagify(input, {
            whitelist: whiteList,
            enforceWhitelist: true
          })

          this.tagify.on('add', () => {
            if (this.tagify.value.length > 1) {
              let last = this.tagify.value[this.tagify.value.length - 1]

              this.tagify.removeAllTags()

              this.tagify.addTags([last])
            }
            this.searchManufacturers()
            //
          })
            .on('remove', this.searchManufacturers)
        }, 100)
      })
    }

  },

  mounted () {
    let localUser = this.$localStorage.get('user')
    this.is_loggedin = localUser != null

    LocationHelper.getMyLocation().then(position => {
      this.waiting_location = false
      this.search_params.lat = position.lat
      this.search_params.lng = position.lng
      this.searchManufacturers()
      this.getProducts()
    })
  },
  beforeDestroy () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/Manufacturers.vue